import React from 'react'
import { Box, Chip, Typography } from "@mui/material";
import Switch from '@mui/material/Switch';
import Collapse from '@mui/material/Collapse';
import ReportsTable from '../../components/common/ReportsTable/ReportsTable';
import { useAuth } from '../../components/auth/AuthProvider';
import FormControlLabel from '@mui/material/FormControlLabel';


const ActivityReportsGrid = ({ searchText, tableRef, apiRef }) => {
  const { user, role } = useAuth();
  const [upcomingChecked, setUpcomingChecked] = React.useState(true);
  const [upcomingReportsCount, setUpcomingReportsCount] = React.useState(0);

  const handleUpcomingChange = () => {
    setUpcomingChecked((prev) => !prev);
  }

  const handleUpcomingReportsChange = (count) => {
    setUpcomingReportsCount(count);
  };

  return (
    <Box
        sx={{
            alignItems: "center",
            bgcolor: "#fff",
            py: 1.5
        }}
    >
        <Typography
              variant="subtitle2"
              color="textPrimary"
              sx={{ ml:2, mt: 2, mb: 1 }}
            >
              Actual
            </Typography>

        <ReportsTable 
          searchText={searchText}
          ref={tableRef}
          apiRef={apiRef}
          isScheduled={false}
          showHeader={true}
        />

        {(role === 'partner') && (
          <>
            <Typography
            variant="subtitle2"
            color="textPrimary"
            sx={{ ml: 2, mt: 2, mb: 1 }}
          >
            Upcoming 
            
            <Chip 
              label={upcomingReportsCount} 
              size="small" 
              sx={{ ml: 1, bgcolor: "#D8E6F0" }} 
            />
            
            <Box
              component="img"
              src="https://static.thenounproject.com/png/down-arrow-icon-1136536-512.png"
              alt="Toggle arrow"
              onClick={handleUpcomingChange}
              sx={{
                ml: 1,
                width: 24,
                height: 24,
                cursor: 'pointer',
                transform: upcomingChecked ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s ease',
                display: 'inline-block',
                verticalAlign: 'middle'
              }}
            />
          </Typography>

          <Collapse in={upcomingChecked}>
            <ReportsTable 
              searchText={searchText}
              ref={tableRef}
              apiRef={apiRef}
              isCheckboxColumn={false}
              isScheduled={true}
              showHeader={false}
              onUpcomingReportsChange={handleUpcomingReportsChange} // Pass the callback
            />
          </Collapse>
            
          </>
        )}

    </Box>
  )
}

export default ActivityReportsGrid